<template>
  <NuxtLayout name="default">
    <template #menu>
      <TitleMenu table="design" />
    </template>
    <slot />
  </NuxtLayout>
</template>
